import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PrimeIcons } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import { TableActionButton, TableColumn } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';
import {
  MarketingGlampointsAction,
  MarketingGlampointsService
} from 'src/app/services/marketing-glampoints.service';

@Component({
  selector: 'app-glampoints-actions',
  templateUrl: './glampoints-actions.component.html',
  styleUrl: './glampoints-actions.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class GlampointsActionsComponent implements OnInit {
  private service = inject(MarketingGlampointsService);
  private title = inject(Title);
  private router = inject(Router);

  actions: MarketingGlampointsAction[] = [];

  columns: TableColumn[] = [
    new TableColumn.Builder()
      .setHeader('ID')
      .setField('id')
      .setType('number')
      .setFilter(false)
      .setRouterLink((a: MarketingGlampointsAction) => `/marketing/glampoints-actions/${a.id}`)
      .build(),
    new TableColumn.Builder()
      .setHeader('Nome')
      .setField('name')
      .setType('text')
      .setCondition('contains')
      .setRouterLink((a: MarketingGlampointsAction) => `/marketing/glampoints-actions/${a.id}`)
      .build(),
    new TableColumn.Builder()
      .setHeader('Pontos')
      .setField('points')
      .setType('formattedNumber')
      .build(),
    new TableColumn.Builder()
      .setHeader('Status')
      .setField('status')
      .setType('text')
      .setCondition('equals')
      .setDisplayFunction((a: MarketingGlampointsAction) =>
        a.status === 'ACTIVE'
          ? 'Ativa'
          : a.status === 'GENERATED'
            ? 'Gerada'
            : 'Inativa'
      )
      .build(),
    new TableColumn.Builder().setHeader('Ações').setType('button').setFilter(false).build()
  ];

  actionButtons: TableActionButton[] = [
    new TableActionButton.Builder()
      .setLabel('')
      .setIcon(PrimeIcons.SEND)
      .setAction((a: MarketingGlampointsAction) =>
        this.router.navigate(['/marketing/glampoints-actions', a.id, 'credit'])
      )
      .setTooltip('Creditar glampoints')
      .setDisplay((a: MarketingGlampointsAction) => a.status === 'ACTIVE')
      .setRounded(true)
      .setText(true)
      .setSeverity('primary')
      .setSize('small')
      .build(),
    new TableActionButton.Builder()
      .setLabel('')
      .setIcon(PrimeIcons.HISTORY)
      .setAction((a: MarketingGlampointsAction) =>
        this.router.navigate(['/marketing/glampoints-actions', a.id, 'history'])
      )
      .setTooltip('Histórico da ação')
      .setDisplay((a: MarketingGlampointsAction) => a.status === 'GENERATED')
      .setRounded(true)
      .setText(true)
      .setSize('small')
      .build()
  ];

  async ngOnInit(): Promise<void> {
    this.title.setTitle('Marketing - Ações de Glampoints');
    await this.loadActions();
  }

  async loadActions(): Promise<void> {
    LoaderService.showLoader();
    try {
      this.actions = await lastValueFrom(this.service.listActions());
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }
}
